export const config = {
  title: "Arianna Cleaning Services | Professional Cleaning | Baltimore, MD",
  meta: {
    description:
      "Arianna Cleaning Services transforms dirty spaces into sparkling sanctuaries with residential, commercial, move-in/out, and post-construction cleaning services in Baltimore, MD.",
    keywords: [
      "Arianna Cleaning Services",
      "Cleaning Services Baltimore",
      "Residential Cleaning MD",
      "Commercial Cleaning Baltimore",
      "Move In Move Out Cleaning",
      "Post Construction Cleaning",
      "House Cleaning Baltimore",
      "Professional Cleaning"
    ],
    author: "Arianna Cleaning Services",
    canonicalUrl: "https://ariannacleaningservice.com/",
  },
  sections: {
    header: {
      businessName: "Arianna Cleaning Services",
    },
    sectionB: {
      heroTitle: "Sparkling Spaces, Satisfied Clients",
      heroSubtitle: "Transforming Dirty Spaces into Sparkling Sanctuaries in Baltimore, MD",
      learnAboutText: "Get Your Free Quote",
      phoneNumber: "4109919309",
      phoneLabel: "(410) 991-9309",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2209016975/photo/young-man-in-uniform-vacuum-cleaning-the-floor-in-the-conference-room.jpg?s=612x612&w=0&k=20&c=ZMZxYxC4wiWGKkg4AFgzKmHQfpc5MU9XcCEogJYwBaQ=",
      cardData: [
        {
          title: "Residential Cleaning",
          description:
            "Professional and reliable residential cleaning service ensuring your home is spotless and sparkling with high-quality products.",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Comprehensive commercial cleaning solutions from dusting and vacuuming to disinfecting and sanitizing for a germ-free environment.",
        },
        {
          title: "Move-In/Move-Out Cleaning",
          description:
            "Hassle-free move cleaning service ensuring your new home is spotless and your old one is left sparkling clean.",
        },
      ],
      description:
        "Arianna Cleaning Services transforms dirty spaces into sparkling sanctuaries with top-notch residential, commercial, move-in/out, and post-construction cleaning services in Baltimore, MD.",
    },
    sectionC: {
      servicesTitle: "Our Professional Cleaning Services",
      servicesDescription:
        "Comprehensive cleaning solutions for residential and commercial spaces in Baltimore and surrounding areas including Hampden, Canton, Federal Hill, and Fells Point.",
      cards: [
        {
          title: "Residential Cleaning",
          description:
            "Leave the dirty work to us! Our professional residential cleaning service uses high-quality products and pays attention to every detail for a fresh, spotless home.",
          imageSrc: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Residential Cleaning Services",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Comprehensive commercial cleaning providing effective solutions for all your business needs, ensuring a spotless and healthy work environment.",
          imageSrc: "https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Commercial Cleaning Services",
        },
        {
          title: "Post-Construction Cleaning",
          description:
            "Ultimate satisfaction with our top-notch post-construction cleaning services, removing debris and dust left behind from construction work.",
          imageSrc: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2076&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Post-Construction Cleaning",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Move-In/Move-Out Cleaning",
        "One-Time Cleaning",
        "Recurring Cleaning Plans",
        "Deep Cleaning Services",
        "Customized Cleaning Solutions",
      ],
    },
    sectionD: {
      aboutTitle: "About Arianna Cleaning Services",
      aboutImage: {
        src: "https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/26dae7bf-ac85-40cd-a666-b32c96fc7d9ecd6a.png?alt=media&token=3ade8e59-2fbb-4961-88b5-9d185045ec65",
        alt: "Arianna Cleaning Services Team",
      },
      aboutText: [
        "Arianna Cleaning Services is Baltimore's trusted cleaning service provider, dedicated to transforming dirty spaces into sparkling sanctuaries. We specialize in residential, commercial, move-in/out, and post-construction cleaning services throughout Baltimore and surrounding areas.",
        "Our professional team uses high-quality products and pays attention to every detail to ensure your space is left spotless, sparkling clean, and germ-free. We offer both one-time and recurring cleaning services, working with you to create customized cleaning plans that fit your specific needs and schedule.",
      ],
    },
    sectionE: {
      profileImage: "https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/26dae7bf-ac85-40cd-a666-b32c96fc7d9ecd6a.png?alt=media&token=3ade8e59-2fbb-4961-88b5-9d185045ec65",
      profileAlt: "Arianna Cleaning Services",
      businessName: "Arianna Cleaning Services",
      contact: {
        phone: "4109919309",
        phoneLabel: "(410) 991-9309",
        email: "info@ariannacleaningservice.com",
        website: "https://ariannacleaningservice.com/",
        address: "Baltimore, MD",
      },
      socialMedia: {
      },
    },
    sectionF: {
      address: "Baltimore, MD",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d198245.123456789!2d-76.6121893!3d39.2903848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c803aed6f483b7%3A0x44896a84223e758!2sBaltimore%2C%20MD!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;